export class GameConstants {

    public static readonly VERSION = "1.0";
    public static readonly GAME_WIDTH = 960;
    public static readonly GAME_HEIGHT = 640;

    public static readonly DEVELOPMENT = false;
    public static readonly ANIMATION_SCENES = false;
    public static readonly VERBOSE = false;
    public static readonly FORCE_MOBILE = false;

    public static readonly INITIAL_SPEED = 1.5;

    public static SPONSOR_NONE = "NONE";
    public static SPONSOR_IZZYGAMES = "IZZYGAMES";
    public static SPONSOR_FUNO = "FUNO";
    public static SPONSOR_LAGGED = "LAGGED";
    public static SPONSOR_GAME_DISTRIBUTION = "GAME DISTRIBUTION";
    public static SPONSOR = GameConstants.SPONSOR_GAME_DISTRIBUTION;

    public static readonly AI_MODE = false;

    public static readonly START_SCENE = "SplashScene";

    public static readonly ROOM_PRICE = 1000;

    // para el juego de higher and lower
    public static readonly HIGHER = "higher";
    public static readonly LOWER = "lower";

    public static readonly SUIT_HEARTS = "h";
    public static readonly SUIT_CLUBS = "c";
    public static readonly SUIT_SPADES = "s";
    public static readonly SUIT_DIAMONDS = "d";

    // hand states
    public static readonly PRE_FLOP = "pre-flop";
    public static readonly FLOP = "flop";
    public static readonly TURN = "turn";
    public static readonly RIVER = "river";

    // wins
    public static readonly HIGH_CARD = "high_card";
    public static readonly PAIR = "pair";
    public static readonly TWO_PAIR = "two_pair";
    public static readonly THREE_OF_A_KIND = "three_of_a_kind";
    public static readonly STRAIGHT = "straight";
    public static readonly FLUSH = "flush";
    public static readonly FULL_HOUSE = "full_house";
    public static readonly FOUR_OF_A_KIND = "four_of_a_kind";
    public static readonly STRAIGHT_FLUSH = "straight_flush";
    public static readonly ROYAL_FLUSH = "royal_flush";

    // player state
    public static readonly ACTIVE = "active";
    public static readonly INACTIVE = "inactive";

    // bet types
    public static readonly FOLD = "fold";
    public static readonly CHECK = "check";
    public static readonly CALL = "call";
    public static readonly RAISE = "raise";
    public static readonly ALL_IN = "all_in";

    public static BIG_BLINDS = [10, 20, 40, 60, 100, 200, 400, 600, 1000, 2000, 4000, 6000];

    public static readonly TIMEOUT = 10;
    public static readonly ADVERSARYS_LENGTH = 5;

    public static readonly BITMAP_SIZE = 64;

    public static readonly LEFT = "left";
    public static readonly RIGHT = "right";

    public static readonly ENFADO2 = "enfado2";
    public static readonly ENFADO1 = "enfado1";
    public static readonly NEUTRO = "neutro";
    public static readonly CONTENTO1 = "contento1";
    public static readonly CONTENTO2 = "contento2";

    public static readonly BOT_STATES = [GameConstants.ENFADO2, GameConstants.ENFADO1, GameConstants.NEUTRO, GameConstants.CONTENTO1, GameConstants.CONTENTO2];
    public static readonly ADVERSARIES = ["zombie", "moai", "sloth", "burger-teen", "demon", "monkey", "richMan"];

    public static readonly SAVED_GAME_DATA_KEY = "poker-king-saved-data-key";
}
